<template>
  <div id="dataTableAcuerdosLineas" class="w-100">
    <!-- Contenido de la tabla -->
    <div :class="load ? 'd-block w-100' : 'd-none'">
      <Loading />
    </div>
    <div :class="load ? 'd-none' : ' w-100'">
      <table class="table table-bordered table-hover  w-100" :id="nombreTabla">
        <thead>
          <tr>
            <th>N°</th>
            <th>Naviera</th>
            <th>Naviera Salida</th>
            <th>POL</th>
            <th>POD</th>
            <th width="175px">Desde</th>
            <th width="175px">Hasta</th>
            <th width="50px">TT </th>
            <th width="75px">Neta (Costo)</th>
            <th width="75px">Pública (Venta)</th>
            <th width="75px">Dcto</th>
            <th>Unidad</th>
            <th width="75px">Commodity</th>
            <th>Atmósfera</th>
            <th>Trat. frío</th>
            <th width="50px">FDO</th>
            <th width="50px">PDO</th>
            <th width="50px">FDD</th>
            <th width="50px">PDD</th>
            <th width="25px">Genset</th>
            <th width="25px">Get Out</th>
            <th width="125px">Comentarios</th>
            <th>Tipo Contrato</th>
            <th width="500px">Contrato-Número</th>
          </tr>
        </thead>

        <tbody>
          <template>
            <tr v-for="(item, index) in dataAux" :key="index">
              <td style="text-align: center; font-size: 11px" v-text="index + 1"></td>
              <td >
                <ui-select
                  has-search
                  placeholder="Seleccionar"
                  searchPlaceholder="Buscar"
                  :options="dataListaNaviera"
                  class="p-0 mt-2"
                  v-model="item.naviera"
                  :keys="{ value: 'id', label: 'name' }"
                  @change="getContract( index ); navierasSalidaList(item);"
                />
              </td>
              <td >
                <ui-select
                  has-search
                  placeholder="Seleccionar"
                  searchPlaceholder="Buscar"
                  :options="item.navieras_salida_list"
                  class="p-0 mt-2"
                  v-model="item.naviera_salida"
                  :keys="{ value: 'id', label: 'name' }"
                />
              </td>
              <td >
                <ui-select
                  has-search
                  placeholder="Seleccionar"
                  searchPlaceholder="Buscar"
                  :options="puertos"
                  class="p-0 mt-2"
                  v-model="item.pol"
                  :keys="{ value: 'id', label: 'name' }"
                />
              </td>
              <td>
                <ui-select
                  has-search
                  placeholder="Seleccionar"
                  searchPlaceholder="Buscar"
                  :options="puertos"
                  class="p-0 mt-2"
                  v-model="item.pod"
                  :keys="{ value: 'id', label: 'name' }"
                />
              </td>
              <td >
                <date-picker
                  placeholder="Fecha"
                  type="date"
                  class="w-100 p-0 mb-3 mr-3 input_fecha mt-2"
                  value-type="format"
                  v-model="item.from_date"
                />
              </td>
              <td>
                <date-picker
                  placeholder="Fecha"
                  type="date"
                  class="w-100 p-0 mb-3 mr-3 input_fecha mt-2"
                  value-type="format"
                  v-model="item.to_date"
                />
              </td>
              <td>
                <input
                  class=" w-100 p-0 form-control"
                  placeholder="TT"
                  v-model="item.transit_time"
                />
              </td>
              <td>
                <input
                  class="w-100 p-0 form-control"
                  placeholder="Neta (Costo)"
                  v-model="item.neta"
                  @change="cambiaValorDescuento(index)"
                />
              </td>
              <td>
                <input
                  class="w-100 p-0 form-control"
                  placeholder="Pública (Venta)"
                  v-model="item.public_value"
                  @change="cambiaValorDescuento(index)"
                />
              </td>
              <td>
                <input        
                  class="w-100 p-0 form-control"
                  v-model="item.descuento"
                  disabled
                />
              </td>
              <td >
                <ui-select
                  has-search
                  placeholder="Seleccionar"
                  searchPlaceholder="Buscar"
                  v-model="item.container_id"
                  :options="selectContainers"
                  class="mt-2"
                  :keys="{ value: 'id', label: 'code' }"
                  @change="setAtmosphereOptions(index)"
                />
              </td>
              <td>
                <ui-select
                  has-search
                  placeholder="Seleccionar"
                  searchPlaceholder="Buscar"
                  :options="commodity"
                  class="p-0 mt-2"
                  v-model="item.products_category_id"
                  :keys="{ value: 'id', label: 'name' }"
                />
              </td>
              <td>
                <ui-select
                  has-search
                  placeholder="Seleccionar"
                  searchPlaceholder="Buscar"
                  :options="item.atmospheres_list"
                  class="mt-2"
                  v-model="item.atmosphere_id"
                  :keys="{ value: 'id', label: 'name' }"
                />
              </td>
              <td>
                <ui-select
                  has-search
                  placeholder="Seleccionar"
                  searchPlaceholder="Buscar"
                  :options="filtroColdtreatment"
                  class="p-0 mt-2"
                  v-model="item.coldtreatment"
                  :keys="{ value: 'id', label: 'name' }"
                />
              </td>
                <td>
                  <input
                    class="w-100 p-0 form-control"
                    placeholder="FDO"
                    v-model="item.free_days_embark"
                  />

                </td>
                <td>
                  <input
                    class="w-100 p-0 form-control"
                    placeholder="PDO"
                    v-model="item.plug_days_embark"
                  />

                </td>
                <td>
                  <input
                    class="w-100 p-0 form-control"
                    placeholder="FDD"
                    v-model="item.free_days_land"
                   />

                </td>
                <td>
                  <input
                    class="w-100 p-0 form-control"
                    placeholder="PDD"
                    v-model="item.plug_days_land"
                  />

                </td>
              <td>
                <input
                  type="checkbox"
                  v-model="item.genset"
                  class="ml-3 mt-3 p-0"
                  style="align-items: center;"
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  v-model="item.get_out"
                  class="ml-3 mt-3 p-0"
                  style="align-items: center;"
                />
              </td>
              <td>
               <textarea
                  class="w-100 p-0 form-control"
                  placeholder="Comentarios..."
                  v-model="item.comment"
              />
              </td>
              <td>
                <ui-select
                  has-search
                  placeholder="Seleccionar"
                  searchPlaceholder="Buscar"
                  :options="tipoContratos"
                  v-model="item.tipo_contrato_id"
                  class="mt-2"
                  :keys="{ value: 'id', label: 'name' }"
                  @change="getContract( index )"
                />
              </td>
              <td>
                <!-- <select class="form-control" v-model="item.contractsList">

                  <option value="">Seleccione una opcion</option>
                  <option v-for="(contracts,index) in contractsList" :key="index" :value="tariff_contract_id">
                    {{contracts.name}}
                  </option>
                </select> -->
                <ui-select
                  has-search
                  class="mt-2"
                  placeholder="Seleccionar"
                  searchPlaceholder="Buscar"
                  :options="item.contractsList"
                  v-model="item.tariff_contract_id"
                  :keys="{ value: 'id', label: 'name' }"
                />
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

// Importación de Jquery
import $ from "jquery";
import DatePicker from "vue2-datepicker";
import Loading from "../../common/loading.vue";
import { getContratosPorNavieraYTipo } from "@/constants/lineas";


export default {
  components: { DatePicker, Loading },
  // components: { UiTextbox },
  props: {
    check: Boolean, // Permite agregar un checkbox como primer elemento de la tabla, esta opción esta deshabilitada por defecto
    customHeaders: Boolean, // Permite asignar el ancho de cada cabecera mediante un array de configuración {title: '', width: ''}
    headers: Array, // Titulos para cabecera de la tabla
    data: Array, // Contenido o información que mostrara la tabla
    acciones: Array, // Array de configuraciones para botones de la columna "Acciones"
    paginacion: Boolean, // Si la tabla tedra activa la opción de paginación, esta opción esta deshabilitada por defecto
    max: { type: Number, default: 10 }, // Numero de filas por cada pagina
    buscar: Boolean, // Filtrar filas, esta opción esta deshabilitada por defecto
    idtabla: {
      type: String,
      default: "id_generico",
    },
    load: Boolean,
    filtroCommodity: Array,
    filtroContenedores: Array,
    filtroAtmosferas: Array,
    filtroColdtreatment: Array,
  },

  data() {
    return {
      loading: true,
      lang: {
        lengthMenu: "Display _MENU_ records per page",
        zeroRecords: "No se encontraron registros coincidentes",
        info: "Mostrando página _PAGE_ de _PAGES_",
        infoEmpty: "No hay registros disponibles",
        infoFiltered: "(filtrado de _MAX_ registros totales)",
        search: "Buscar",
        paginate: {
          first: "Primero",
          last: "Ultimo",
          next: "Siguiente",
          previous: "Anterior",
        },
        buttons: {
          colvis: "Seleccionar columnas",
        },
      },
      nombreTabla: "id_tabla_" + this.idtabla,
      dataAux: this.data,
      accionesAux: this.acciones,
      flagFormulario: false,
      options: [],
      selected: [],
      selectAll: false,
      // contratos: [],
      contracts: [],
      filtroContainers: this.filtroContenedores,
      filtroTipoProductos: this.filtroCommodity,
      filtroAtmo: this.filtroAtmosferas,
    };
  },
  computed: {
    ...mapState("lineas", [
      "dataListaNaviera",
      "dataListaNavierasNoUCC",
      "dataListaProducto",
      "selectAtmospheres",
      "selectContainers"
    ]),
    ...mapState("administracion", ["dataDatatableAtmosferas"]),
    ...mapState([
      "tipoContratos",
      "contratos",
      "clientes",
      "navieras",
      "puertos",
      "atmosferas",
      "destinos",
      "commodity",
      "tipoContratos",
      "contenedores", 
      "estados",
      "listaClientesUsuarioActual"
      ]),
  },
  methods: {
    setAtmosphereOptions(index) {

      this.dataAux[index].atmosphere_id = '';

      this.dataAux[index].atmospheres_list = [];

      let atmospheres = this.selectAtmospheres;

      if (this.dataAux[index].container_id.ac === 0) {

        this.dataAux[index].atmospheres_list = atmospheres.filter(item => item.id === 13);

      } else {

        this.dataAux[index].atmospheres_list = atmospheres.filter(item => item.id !== 13);

      }

    },
    cambiarEstadoCheck(event, id) {
      let estado = event.target.checked;
      let accion = "fila_chekeada";
      this.filaChekeada({ id, estado, accion });
    },
    cambiaValorDescuento(index) {
      const descuento =
        parseInt(this.data[index].public_value) -
        parseInt(this.data[index].neta);
      this.data[index].descuento = descuento > 0 ? descuento : 0;
    },
    select() {
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.options) {
          this.selected.push(this.options[i]);
        }
      }
    },
    navierasSalidaList(row) {

      if (row.naviera.name !== "UCC") {

        let current_row = this.dataAux[this.dataAux.findIndex(x => x.id === row.id)];

        current_row.naviera_salida = row.naviera;

        current_row.navieras_salida_list = [row.naviera];

      } else {

        let current_row = this.dataAux[this.dataAux.findIndex(x => x.id === row.id)].navieras_salida_list = this.dataListaNavierasNoUCC;

        current_row.naviera_salida = "";

      }
    },
    updateCheckall: function () {
      if (this.options.length === this.selected.length) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },
    cambiarEstadoTodosCHECK() {
    },
    // Acciones de Vuex
    ...mapActions(["ActionSetLoading"]),
    filaSeleccionada(id, accion) {
      this.seleccionar({ id, accion });
    },
    async getContract( index ){
      
      const { naviera , tipo_contrato_id  } = this.dataAux[index] ;

      const form = {
        naviera_id: naviera.id ?? "",
        type: tipo_contrato_id.id
      };

      try {
        const contracts = await getContratosPorNavieraYTipo( form ) ;
        this.dataAux[index].contractsList = contracts ;

      }catch( error ){
        console.log("error --->" , error);
      }

    },
    async getContracts(){

      if( !this.dataAux && this.dataAux.length === 0 ) return false ;

      let i = 0 ;
      for await (const value of this.dataAux ) {

        const { naviera , tipo_contrato_id  } = value ;

        const form = {
          naviera_id: naviera.id ?? "",
          type: tipo_contrato_id.id
        };

        try {
          const contracts = await getContratosPorNavieraYTipo( form ) ;
          this.dataAux[i].contractsList = contracts ;

        }catch( error ){
          console.log("error --->" , error);
        }

        i++;
      }
      
    },
    configuracionDatatable() {
      let me = this;

      $("#" + this.nombreTabla)
        .DataTable()
        .destroy();

      $("#" + me.nombreTabla)
        .DataTable({
          paging: this.paginacion,
          pageLength: this.max,
          searching: this.buscar,
          lengthChange: false,
          ordering: true,
          info: true,
          autoWidth: false,
          responsive: true,
          checkd: false,
          // buttons: [
          //   "colvis",
          //   {
          //     text: "Hooola",
          //     extend: "excel",
          //     title: "Diego",
          //     exportOptions: {
          //       columns: [0, 1, 2, 3, 4, 5],
          //     },
          //   },
          // ],
          language: me.lang,
        })
        .buttons()
        .container()
        .appendTo("#" + me.nombreTabla + "_wrapper .col-md-6:eq(0)");

      $(".exportar-tabla").click(() => {
        $("#" + me.nombreTabla)
          .DataTable()
          .buttons(2 - 1)
          .trigger();
      });
    },
  },

  mounted() {
    // let me = this;
    // me.configuracionDatatable();
  },

  watch: {
    data: function (_new) {
      let me = this;

      // Si watch detecta un cambio en la variable dataDatatableFilialesFiltrada la cual es un state de vuex, esta asignada el nuevo
      // valor a la variable data
      if (_new) {
        // Se debe destruir la tabla para cargar nuevos datos
        // $("#" + this.nombreTabla)
        //   .DataTable()
        //   .destroy();

        setTimeout(() => {
          me.dataAux = _new;
        }, 300);

        setTimeout(() => {
          // me.configuracionDatatable();
          me.ActionSetLoading(false);
        }, 700);
      }
    },

    acciones: function (_new) {
      if (_new) {
        this.accionesAux = _new;
      }
    },

    cambiarEstadoTodosCHECK: function (_new) {
      if (_new) {
        this.cambiarEstadoTodosCHECK = _new;
      }
    },
    dataAux: function (_new) {
      if( _new ){
        this.getContracts() ;

      }
    },
  },
};
</script>

<style>

#dataTableAcuerdosLineas .form-control{
  border: 0px;
  border-bottom: 1px solid #ced4da;
  border-radius: 0px;
  height: 42px;
}


</style>
